<template>
  <div id="appCapsule">
    <div class="section mt-2">
      <div class="col-12 mg-t-10">
        <div class="get-support-wrapper">
          <div class="get-support-form action-form">
            <div class="support-form-wrp">
              <form
                action="https://unifivaults.com/account/support/"
                method="POST"
              >
                <div class="transfer-form-body">
                  <div class="form-group">
                    <label for="" class="d-block">Email</label>
                    <input
                      disabled
                      id="email"
                      type="text"
                      class="form-control"
                      placeholder="Email Address"
                    />
                  </div>

                  <div class="form-group">
                    <label for="" class="d-block">Subject</label>
                    <input
                      v-model="subject"
                      id="subject"
                      type="text"
                      class="form-control"
                      placeholder="Subject"
                    />
                  </div>

                  <div class="form-group">
                    <label for="" class="d-block">Message</label>
                    <textarea
                      v-model="message"
                      id="message"
                      class="form-control"
                      placeholder="Your Message"
                    ></textarea>
                  </div>
                </div>

                <div class="transfer-form-footer" style="margin-top: 10px">
                  <div class="tr-group-submit">
                    <button
                      :disabled="processing"
                      class="btn btn-secondary cancel-support"
                      type="button"
                    >
                      CANCEL
                    </button>
                    <button
                      @click.prevent="emailSupport"
                      :disabled="processing"
                      class="btn btn-primary"
                      type="submit"
                      name="submit"
                    >
                      {{ processing ? "Sending..." : "SUBMIT" }}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { RepositoryFactory as Repo } from "../../../repository/RepositoryFactory";
const AR = Repo.get("users");
export default {
  data() {
    return {
      email: "",
      processing: false,
      subject: "",
      message: "",
    };
  },
  methods: {
    viewCard() {
      $("#modal-account").modal("show");
    },

    async emailSupport() {
      this.processing = true;
      const aData = {
        subject: this.subject,
        message: this.message,
      };
      try {
        await AR.userEmailSupport(aData);
        $("#modal-card").modal("hide");
        this.processing = false;
        toast.fire({
          type: "success",
          title: "Email sent succssfully",
        });
        this.message = "";
        this.subject = "";
      } catch (error) {
        this.processing = false;

        toast.fire({
          type: "error",
          title: error.response.data.message,
        });
      }
    },
  },
  created() {
    AR.loggedInUser().then((response) => {
      this.email = response.data.email;
    });
  },
};
</script>
